import { render, staticRenderFns } from "./GiveModal.vue?vue&type=template&id=30908600&scoped=true"
import script from "./GiveModal.vue?vue&type=script&lang=js"
export * from "./GiveModal.vue?vue&type=script&lang=js"
import style0 from "./GiveModal.vue?vue&type=style&index=0&id=30908600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30908600",
  null
  
)

export default component.exports